import * as t from 'io-ts';
import { VISIBLE_COMPLAINT, VisibleComplaintType } from 'ws-voice-infinity-global-module/lib/enums';
import { IPublicStatusComplaintItem, SimpleObjectInterface } from 'ws-voice-infinity-global-module/lib/interfaces';
import { ComplaintFlagsEntry, ComplaintFlagsEntryType, ComplaintSubject, ComplaintSubjectType, DictionaryEntry, DictionaryEntryType, EntityAttachment, EntityAttachmentType, ObjectMin, ObjectMinType, Rating, RatingType, UserDescriptorEntryMin, UserDescriptorEntryMinType } from 'ws-voice-infinity-global-module/lib/models';
import PUBLIC_STATUS_COMPLAINT from '../enums/publicStatusComplaint';
import { ComplaintTimer, ComplaintTimerType } from './complaintTimer';

export const ComplaintListType = t.interface({
    address: t.union([t.string, t.null]),
    attachments: t.union([t.array(EntityAttachmentType), t.null]),
    author: t.union([UserDescriptorEntryMinType, t.undefined, t.null]),
    content: t.union([t.string, t.null]),
    countUnreadExecutions: t.union([t.number, t.null, t.undefined]),
    currentActiveTimer: t.union([ComplaintTimerType, t.null, t.undefined]),
    currentExecutor: t.union([ObjectMinType, t.null, t.undefined]),
    expiredStatus: t.union([t.string, t.null, t.undefined]),
    flags: t.union([ComplaintFlagsEntryType, t.null, t.undefined]),
    id: t.string,
    internalStatus: t.union([t.string, t.null, t.undefined]),
    locality: t.union([DictionaryEntryType, t.null, t.undefined]),
    municipality: t.union([DictionaryEntryType, t.null]),
    number: t.union([t.number, t.null]),
    operator: t.union([ObjectMinType, t.null, t.undefined]),
    publicStatus: t.union([t.string, t.null]),
    responseNotificationAddress: t.union([t.string, t.null, t.undefined]),
    sedNumber: t.union([t.string, t.null, t.undefined]),
    subject: t.union([ComplaintSubjectType, t.null]),
    submitDate: t.union([t.string, t.number, t.null]),
    visible: t.union([VisibleComplaintType, t.undefined, t.null]),
    rating: t.union([RatingType, t.null, t.undefined]),
});

export interface ComplaintListDTO extends t.TypeOf<typeof ComplaintListType> {
}

export class ComplaintList {
    address: string | null;
    attachments: EntityAttachment[];
    author: UserDescriptorEntryMin | null;
    content: string | null;
    countUnreadExecutions: number | null;
    currentActiveTimer: ComplaintTimer | null;
    currentExecutor: ObjectMin | null;
    expiredStatus: string | null;
    flags: ComplaintFlagsEntry | null;
    id: string;
    internalStatus: string | null;
    municipality: DictionaryEntry | null;
    number: number | null;
    locality?: DictionaryEntry | null;
    operator: ObjectMin | null;
    publicStatus: IPublicStatusComplaintItem | null;
    responseNotificationAddress: string | null;
    sedNumber: string | null;
    subject: ComplaintSubject | null;
    submitDate: Date | null;
    visible: SimpleObjectInterface;
    rating: Rating | null;

    constructor(params: ComplaintListDTO) {
        this.address = params.address;
        this.attachments = params.attachments && params.attachments.length
            ? params.attachments.map(attachment => new EntityAttachment(attachment))
            : [];
        this.author = params.author ? new UserDescriptorEntryMin(params.author) : null;
        this.content = params.content;
        this.countUnreadExecutions = params.countUnreadExecutions ? params.countUnreadExecutions : 0;
        this.currentActiveTimer = params.currentActiveTimer ? new ComplaintTimer(params.currentActiveTimer) : null;
        this.currentExecutor = params.currentExecutor ? new ObjectMin(params.currentExecutor) : null;
        this.expiredStatus = params.expiredStatus ? params.expiredStatus : null;
        this.flags = params.flags ? new ComplaintFlagsEntry(params.flags) : null;
        this.id = params.id;
        this.internalStatus = params.internalStatus ? params.internalStatus : null;
        this.municipality = params.municipality ? new DictionaryEntry(params.municipality) : null;
        this.number = params.number;
        this.locality = params.locality ? new DictionaryEntry(params.locality) : null;
        this.operator = params.operator ? new ObjectMin(params.operator) : null;
        this.publicStatus = params.publicStatus ? PUBLIC_STATUS_COMPLAINT[params.publicStatus] : null;
        this.responseNotificationAddress = params.responseNotificationAddress ? params.responseNotificationAddress : null;
        this.sedNumber = params.sedNumber ? params.sedNumber : null;
        this.subject = params.subject ? new ComplaintSubject(params.subject) : null;
        this.submitDate = params.submitDate ? new Date(params.submitDate) : null;
        this.visible = params.visible ? VISIBLE_COMPLAINT[params.visible] : VISIBLE_COMPLAINT.VISIBLE;
        this.rating = params.rating ? new Rating(params.rating) : null;
    }
}
